import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ReadOnlyData = ({label, value}) => {
  return <Box my={0.5} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1}}>
    <Typography sx={{minWidth: '90px', fontWeight: 900}}>{label}</Typography>
    <Typography>{value}</Typography>
  </Box>;
};

ReadOnlyData.propTypes = {
  label: PropTypes.string.isRequired,
  value:  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
};

export default ReadOnlyData;